import apis from '@/pages/activity-manage/proSalesData/apis';
export const PROSALESDATA_GOODINFO = 'PROSALESDATA_GOODINFO';

export const proSalesDataGoodInfo = (data) => (dispatch, getState) => {
  apis.proSalesDataGoodInfo(data).then((res) => {
    if (res && res.ret === '0') {
      dispatch({
        type: PROSALESDATA_GOODINFO,
        payload: res.data,
      });
    } else {
      dispatch({
        type: PROSALESDATA_GOODINFO,
        payload: initialState,
      });
    }
  });
};

export const resetPlanData = function () {
  return {
    type: 'RESET_PLAN_DATA',
  };
};

const initialState = {
  // 是否有查看当前活动的权限
  productlist: [],
};

export default function activityPlan(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case PROSALESDATA_GOODINFO:
      return Object.assign({}, state, payload);

    default:
      return state;
  }
}
